/**
 * What the Events Activity chart's latency line plots.
 *
 * Its own module rather than a constant on `admin-ops.api`: tests mock that
 * module wholesale, so a runtime value living there disappears for every
 * consumer the moment somebody mocks the API. Mirrors
 * `EVENTS_CHART_LATENCY_METRICS` in `@nexus/db` — the web app does not import
 * from that package, so the union is restated here and pinned by
 * `admin-ops-chart-metric.test.ts`.
 */
export const EVENTS_CHART_LATENCY_METRICS = ["endToEnd", "run", "both"] as const;

export type EventsChartLatencyMetric = (typeof EVENTS_CHART_LATENCY_METRICS)[number];
